import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CKEditor from 'ckeditor4-react'
import { ckeditorToolbar } from '../../helpers'
import { GlgPopup, GlgSwitch, GlgRangeSlider, GlgColorPicker } from 'SharedComponents'
import { TEXT_TYPE } from '../../constants'
import { Row, Col } from 'react-flexbox-grid'


class TextSlidePopupComponent extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      isSaving: false,
    }

    this.saveToDB = this.saveToDB.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { scrollRate, backgroundOpacity, text, bgColor } = this.props
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState({ scrollRate, backgroundOpacity, text, bgColor})
    }
  }

  saveToDB() {
    const {
      text,
      bgColor,
    } = this.state
    
    const {
      slideId,
      isVisible,
      backgroundImage,
      scrollRate,
      backgroundOpacity,
      rounds,
    } = this.props

    const slide = {
      slideId,
      visible: isVisible,
      type: TEXT_TYPE,
      description: 'Text Slide',
      background: backgroundImage,
      scrollRate: scrollRate,
      settings: {
        round_id: rounds.length > 0 && rounds[0].value ? rounds[0].value : null,
        displayType: TEXT_TYPE,
        backgroundOpacity,
        text,
        bgColor,
      },
    }
    this.setState({ isSaving: true })
    $.ajax({
      url: this.props.paths.saveSlide,
      type: 'POST',
      data: slide,
      success: (response) => {
        if (slideId) {
          this.props.updateSlide({
            id: slideId,
            type: TEXT_TYPE,
            description: 'Text Slide',
            visible: slide.visible,
          })
        } else {
          this.props.addSlide({
            id: response.id,
            type: TEXT_TYPE,
            description: 'Text Slide',
            visible: slide.visible,
          })
        }
        this.setState({ isSaving: false }, this.props.onClose)
      },
      error: () => {
      },
    })
  }

  setEditorDefaultConfiguration(editor) {
    if ( (editor.getData() || '').length > 0) {
      return
    }
    const usgaDefaultStyle = 
      `<p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %event.name%
        </span></span>
      </p>`
    const regularDefaultStyle =
      `<p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %event.name%
        </span></span>
      </p>
      <p style="text-align: center">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 20px;">
          %round.date%
        </span></span>
      </p>`
    const brand = 'usga'
    const defaultStyle = brand === 'usga' ? usgaDefaultStyle : regularDefaultStyle
    editor.setData( defaultStyle )
  }
  render() {
    const {
      slideId,
      backgroundOpacity,
      show,
      onClose,
      eventDescriptionFields,
      productName,
    } = this.props

    const {
      text,
      isSaving,
    } = this.state

    return (
      <GlgPopup
        title={ `${slideId ? 'Edit' : 'New' } Text Slide` }
        saveButtonText={ slideId ? 'Update' : 'Save' }
        saveButtonEnabled={ !!this.state.text }
        show={ show }
        modalClass={ 'text-popup' }
        manualClose={ true }
        onClose={ onClose }
        onSave={ this.saveToDB }
        isSaving={ isSaving }>
        <div
          id={'slide_setup'}
          className={'popup_container'}>
          <div className='visible-switch justify-center'>
            <GlgSwitch
              id={ 'leaderboard-visible-switch' }
              text={ [ 'Visible', 'Hidden' ] }
              widthInPixels={ 80 }
              checked={ !!this.props.isVisible }
              onChange={ () => { this.props.setVisible(!this.props.isVisible) } } />
          </div>
          <ul className='no-padding add-margin-top-10'>
            <li className='form_row add-margin-top-20 add-padding-bottom-20'>
              <div className='row popup-section-title no-padding-bottom'>
                <Col xs={ 12 }>
                  { 'Content Transition' }
                </Col>
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 } sm={ 6 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      { 'Scroll Rate' }
                    </Col>
                    <Col xs={ 12 } md={ 8 } lg={ 8 }>
                      <GlgRangeSlider
                        value={ this.props.scrollRate !== undefined ? this.props.scrollRate : 0 }
                        min={ 1 }
                        max={ 20 }
                        unit={ ' seconds' }
                        onChange={ this.props.changeScrollRate } />
                    </Col>
                  </Row>
                </Col>
              </div>
              <div className='row popup-section-title no-padding-bottom add-padding-top-10'>
                <Col xs={ 12 }>
                  { 'Background' }
                </Col>
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 } sm={ 6 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      { 'Color' }
                    </Col>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      <div className='background-container'>
                        <GlgColorPicker
                          name="background[color]"
                          color={ this.state.bgColor }
                          pickerPosition="bottom"
                          disableAlpha={ true }
                          onChange={ color => { this.setState({bgColor: color.hex}) } } />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 } sm={ 6 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      { 'Opacity' }
                    </Col>
                    <Col xs={ 12 } md={ 8 } lg={ 8 }>
                      <GlgRangeSlider
                        value={ backgroundOpacity || 0 }
                        min={ 0 }
                        max={ 100 }
                        unit={ '%' }
                        onChange={ (opacity) => { this.props.setBackgroundOpacity(parseInt(opacity)) } } />
                    </Col>
                  </Row>
                </Col>
              </div>
            </li>
            <li className='form_row add-margin-top-20 add-padding-bottom-20'>
              <div className='row popup-section vertical-align-items no-padding-bottom justify-center add-padding-bottom-20'>
                {eventDescriptionFields.map( ([ label, placeholder ], index) => (
                  <a
                    className='insert-in-ckeditor'
                    key={ index }
                    onClick={ () => { this.state.editor.insertText(placeholder) } }>
                    { label.replace('%product%', productName) }
                  </a>
                ))}
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 }>
                  <CKEditor
                    id="header_content_textarea"
                    data={ text }
                    onChange={ (e) => this.setState({ text: e.editor.getData() }) }
                    onInstanceReady={ e => {
                      this.setState({ editor: e.editor})
                      this.setEditorDefaultConfiguration(e.editor)
                      window.glg.translation.ckeditorHtmlLang(e.editor)
                    } }
                    config={{
                      toolbar: ckeditorToolbar,
                      resize_maxHeight: 600,
                      height: 300,
                    }} />
                </Col>
              </div>
            </li>
          </ul>
        </div>
      </GlgPopup>
    )
  }
}

TextSlidePopupComponent.propTypes = {
  paths: PropTypes.object.isRequired,
  slideId: PropTypes.string,
  type: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
  backgroundImage: PropTypes.string,
  setVisible: PropTypes.func,
  addSlide: PropTypes.func.isRequired,
  updateSlide: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  link: PropTypes.string,
  scrollRate: PropTypes.number,
  changeScrollRate: PropTypes.func,
  backgroundOpacity: PropTypes.number,
  setBackgroundOpacity: PropTypes.func.isRequired,
  text: PropTypes.string,
  rounds: PropTypes.array.isRequired,
  bgColor: PropTypes.string,
  eventDescriptionFields: PropTypes.array.isRequired,
  productName: PropTypes.string.isRequired,
}

export default TextSlidePopupComponent
